import dayjs from 'dayjs'

import {
  BACKEND_DATE_FORMAT,
  BACKEND_DATE_FORMAT_2,
  DATE_FORMAT_STRING,
  IS_DATETIME_FORMAT,
  TIME_FORMAT_STRING,
} from '/@src/constants'

export function parseDateTimeString(value: string, originalValue: string) {
  const date = dayjs(
    originalValue,
    [BACKEND_DATE_FORMAT, BACKEND_DATE_FORMAT_2, IS_DATETIME_FORMAT],
    true
  )
  return date.isValid() ? date.toDate() : new Date('')
}

export function parseDateString(value: string, originalValue: string) {
  const isValidDate = dayjs(originalValue, DATE_FORMAT_STRING, true).isValid()
  return isValidDate ? dayjs(originalValue).toDate() : new Date('')
}

export function parseTimeString(value: string, originalValue: string) {
  const isValidTime = dayjs(originalValue, TIME_FORMAT_STRING, true).isValid()
  return isValidTime ? originalValue : ''
}

export function safeDomId(id: string) {
  return id.replace(/[^a-zA-Z0-9-]/g, '')
}
